<div class="row">
  <div class="col-12">
    <h5> {{'common.latestTransactions' | translate}} </h5>
  </div>
</div>
<div class="row mb-2" *ngFor="let item of transactions">
  <div class="col-2 text-center p-1">
    <ngx-skeleton-loader
      *ngIf="loading"
      [theme]="{
        width: '40px',
        height: '40px',
        'border-radius': '8px'
      }"
    ></ngx-skeleton-loader>
    <div
      *ngIf="!loading"
      class="text-center transaction-icon-container rounded-10"
    >
      <i
        *ngIf="item.textColor == 'success'"
        class="mdi mdi-cash-plus text-success transaction-icon"
      ></i>
      <i
        *ngIf="item.textColor == 'danger'"
        class="mdi mdi-cash-minus text-danger transaction-icon"
      ></i>
    </div>
  </div>
  <div class="col-10">
    <div class="row">
      <div class="col-9">
        <ngx-skeleton-loader *ngIf="loading"></ngx-skeleton-loader>
        <span *ngIf="!loading" class="mb-0 transaction-text">
          {{ item.origem }}
        </span>
      </div>
      <div class="col-3 text-end">
        <ngx-skeleton-loader *ngIf="loading"></ngx-skeleton-loader>
        <span *ngIf="!loading" class="transaction-text-amount">

          {{
            item.valorMovimentado | formatCurrency
          }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-7 text-truncate">
        <ngx-skeleton-loader *ngIf="loading"></ngx-skeleton-loader>
        <small *ngIf="!loading" class="transaction-text-responsible">{{
          item.responsavel
        }}</small>
      </div>
      <div class="col-5 text-end">
        <ngx-skeleton-loader *ngIf="loading"></ngx-skeleton-loader>
        <small *ngIf="!loading" class="transaction-text-date">{{
          item.data | date : "dd MMM yyyy HH:mm"
        }}</small>
      </div>
    </div>
  </div>
</div>
